const watermark = {};

const setWatermark = (str1, targetDom) => {
  const id = "watermark";

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }

  const can = document.createElement("canvas");
  can.width = 300;
  can.height = 200;

  const cans = can.getContext("2d");
  cans.rotate((-20 * Math.PI) / 180);
  cans.font = "100 16px Microsoft JhengHei";
  cans.fillStyle = "rgba(0, 0, 0, 0.15)";
  cans.textAlign = "left";
  cans.textBaseline = "Middle";
  cans.fillText(str1, can.width / 20, can.height);

  const watermark = document.createElement("div");
  watermark.id = id;
  const styleStr = `
    position:fixed;
    top:${targetDom.offsetTop}px;
    left:${targetDom.offsetLeft}px;
    width:${targetDom.clientWidth}px;
    height:${targetDom.clientHeight}px;
    z-index:100000;
    pointer-events:none;
    background-repeat:repeat;
    mix-blend-mode: multiply;
    background-image:url(${can.toDataURL("image/png")});
  `;
  watermark.setAttribute("style", styleStr);
  watermark.classList.add("watermark");
  document.body.appendChild(watermark);

  const observer = new MutationObserver(() => {
    const wmInstance = document.querySelector(".watermark");
    if ((wmInstance && wmInstance.getAttribute("style") !== styleStr) || !wmInstance) {
      //如果标签在，只修改了属性，重新赋值属性
      if (wmInstance) {
        // 避免一直触发
        observer.disconnect();
        console.log("水印属性修改了");
        wmInstance.setAttribute("style", styleStr);
      } else {
        console.log("水印标签被移除了");
        document.body.appendChild(watermark);
        /* 此处根据用户登录状态，判断是否终止监听，避免用户退出后登录页面仍然有水印 */
        // if (store.getters.token) {
        //   //标签被移除，重新添加标签
        //   // console.log('水印标签被移除了');
        //   document.body.appendChild(watermark);
        // } else {
        //   observer.disconnect();
        // }
      }
    }
  });
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    childList: true,
  });
  return id;
};

// 如果水印存在 展示水印 如果不存在 创建之后展示
// targetDom 是水印要盖住的元素
watermark.set = (str1, targetDom) => {
  setWatermark(str1, targetDom);
  window.onresize = () => {
    setWatermark(str1, targetDom);
  };
};
// 页面切换时展示水印 因为项目组件是keep-alive的 所以在beforeRouteEnter的时候调这个
watermark.show = () => {
  if (document.getElementById("watermark")) {
    document.getElementById("watermark").style.display = "block";
  }
};
// beforeRouteLeave切换其他页面时可能需要隐藏水印
watermark.hide = () => {
  document.getElementById("watermark").style.display = "none";
};
export default watermark;
